// extracted by mini-css-extract-plugin
export default {"default":"checkbox_default__yxImE","radio":"checkbox_radio__Jxl9v","active":"checkbox_active__qvC6u","defaultChecked":"checkbox_defaultChecked__GudNT"};